export default function isPrimitive(val) {
  if (val !== null && (typeof val == "object" || typeof val == "function")) {
    return false;
  }
  return true;
}
